function toggleFAQ() {
    var questionTitles = document.querySelectorAll('.js-question_title');

    questionTitles.forEach(function(title) {
        title.addEventListener('click', function() {
            var text = this.nextElementSibling;
            var plusIcon = this.querySelector('.title-plus');
            var minusIcon = this.querySelector('.title-minus');
            var titleText = this.querySelector('.institutional-section-faq_question');

            if (text) {
                text.style.display = (text.style.display === 'none' || text.style.display === '') ? 'block' : 'none';
                if (text.style.display === 'block') {
                    plusIcon.style.display = 'none';
                    minusIcon.style.display = 'block';
                } else {
                    plusIcon.style.display = 'block';
                    minusIcon.style.display = 'none';
                }
            }

            if(text.style.display != 'none'){
                minusIcon.style.color = '#4EA356';
                titleText.style.color = '#4EA356';
            }else{
                minusIcon.style.color = '';
                titleText.style.color = '';
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    toggleFAQ();
});
